<template>
	<div id="description" class="section-description">
		<div class="max-width ">Desarrollamos productos de software , estos tienen un ciclo de vida.  Son creados para solucionar un problema en un nicho de mercado específico. <br>
 		Evaluamos la rentabilidad y el tamaño del  mercado</div>
		 <p class="divider-description"></p>
		 <div class="title-company">
			 Product Studio
		 </div>
	</div>
</template>

<script>
export default {
	name: 'component-description',
};
</script>

<style lang="scss" scoped>
.section-description {
	align-items: center;
	background-color: map-get($colors, white);
	border-radius: 30px;
	bottom: -60px;
	box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.06);
	display: flex;
	justify-content: center;
	left: 50%;
    transform: translateX(-50%);
	margin: 0 auto;
	padding: 35px 100px;
	position: absolute;
	width: 85%;
	z-index: 4;

	@media (max-width: 1024px) {
		bottom: -114px;
		flex-direction: column-reverse;
		padding: 46px 30px;
		width: 92%;
	}

	@media (max-width: 380px) {
		height: 310px;
		top: 600px;
	}
}

.max-width {
	color: map-get($colors, gray);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: map-get($sizes, large);
	line-height: 1.81;
	max-width: 580px;

	@media (max-width: 1024px) {
		text-align: center !important;
	}
}

.title-company {
	color: map-get($colors, regular);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: 40px;
	margin-left: 30px;

	@media (max-width: 1024px) {
		font-size: 24px;
		margin: 0;
	}
}

.divider-description {
	background-color: map-get($colors, gray-divider);
	height: 156px;
	margin-left: 54px;
	width: 2px;

	@media (max-width: 1024px) {
		display: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/component-description.vue